import { render } from "./ConfGoogle.vue?vue&type=template&id=04b64836"
import script from "./ConfGoogle.vue?vue&type=script&lang=js"
export * from "./ConfGoogle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__